/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";

type Props = {
	h: number
}

export class HGap
	extends React.Component<Props> {

	render() {
		return <div style={{width: this.props.h, pointerEvents: 'none'}}/>;
	}

}
